import React from 'react'
import {
  ClassHero,
  ClassInformation,
  ClassImages,
  EnrollHeader,
  EnrollInstructions,
  EnrollDocumentLink,
  PageHeroImage,
  PageBenefitBlocks,
  PageImagesTwo,
  PageFrequentlyAskedQuestions,
  PageContactForm,
  PageSmallParagraph,
  PageSmallImage,
  PageSpace,
  PageEvents,
  PageFeaturedColumns,
  PageMembershipTable,
} from './slices'

const SliceZone = ({ slices }) => {
  const sliceComponents = {
    class_hero: ClassHero,
    class_information: ClassInformation,
    class_images: ClassImages,
    enroll_header: EnrollHeader,
    enroll_instructions: EnrollInstructions,
    enroll_document_link: EnrollDocumentLink,
    hero_image: PageHeroImage,
    benefit_blocks: PageBenefitBlocks,
    images_two: PageImagesTwo,
    frequently_asked_questions: PageFrequentlyAskedQuestions,
    contact_form: PageContactForm,
    small_paragraph: PageSmallParagraph,
    small_image: PageSmallImage,
    space: PageSpace,
    events: PageEvents,
    featured_columns: PageFeaturedColumns,
    membership_table: PageMembershipTable,
  }

  return slices.map((slice, index) => {
    const SliceComponent = sliceComponents[slice.slice_type]
    if (SliceComponent) {
        return <SliceComponent slice={slice} key={`slice-${index}`} />
      }
      return null
    })
}

export default SliceZone
